<template>
  <p class="text-xs text-gray-600 text-center">
    {{ introText }}
    <NuxtLink
      :to="localePath('/oferta')"
      target="_blank"
      rel="noopener noreferrer"
      class="underline"
    >
      {{ $t('legalConsent.oferta') }}
    </NuxtLink>
    {{ $t('legalConsent.and') }}
    <NuxtLink
      :to="localePath('/privacy-policy')"
      target="_blank"
      rel="noopener noreferrer"
      class="underline"
    >
      {{ $t('legalConsent.privacyPolicy') }}
    </NuxtLink>
  </p>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  variant?: 'cart' | 'lot' | 'login'
}>(), {
  variant: 'cart',
})

const { t } = useI18n()
const localePath = useLocalePath()

const introText = computed(() => {
  const key = {
    cart: 'legalConsent.cart',
    lot: 'legalConsent.lot',
    login: 'legalConsent.login',
  }[props.variant]

  return t(key)
})
</script>
